import styled from '@emotion/styled';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

export const OffersSettingsContainer = styled('section', { label: 'OffersSettingsContainer' })`
    margin: 24px 0;
`;

export const OffersSettingsHeader = withConfig(theme => styled('h4', { label: 'OffersSettingsHeader' })`
    font-size: ${theme.star.fontSize.regular};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.5;
    margin: 0 0 8px 0;
`);

export const OffersSettingsSubHeader = withConfig(theme => styled('p', { label: 'OffersSettingsSubHeader' })`
    font-size: ${theme.star.fontSize.small};
    line-height: 1.3333;
    margin: 0;
`);

export const OffersSettingsContentContainer = styled('section', { label: 'OffersSettingsContentContainer' })`
    display: flex;
    margin-top: 16px;
    gap: 16px;
    flex-direction: column;
    text-align: start;
`;

export const OffersSettingsContentRowContainer = styled('div', { label: 'OffersSettingsContentRowContainer' })`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

interface OffersSettingsContentRowsContainerPropsType {
    systemPagesVariant: DefaultComponentVariantType | null;
    additionalContainer: boolean;
}


export const OffersSettingsContentRowsContainer = withConfig(theme => styled('div', { label: 'OffersSettingsContentRowsContainer' })<OffersSettingsContentRowsContainerPropsType>`
    display: flex;
    flex-direction: column;
    gap: 8px;
    border-radius: ${({ systemPagesVariant }): string => systemPagesVariant === DefaultComponentVariantType.SECONDARY ? theme.star.radius.small : '0'};

    ${({ additionalContainer }):string => additionalContainer === true ? `
        padding: 16px;
        background-color: ${theme.star.blockingPopUp.bgColor};
    `: ''}
`);

export const OffersSettingsContentRow = styled('div', { label: 'OffersSettingsContentRow' })`
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-transform: capitalize;
`;

export const OffersSettingsContentRowText = withConfig(theme => styled('span', { label: 'OffersSettingsContentRowText' })`
    font-size: ${theme.star.fontSize.xRegular};
    line-height: 1.4286;
`);

export const OffersSettingsContentHeader = withConfig(theme => styled('h5', { label: 'OffersSettingsContentHeader' })`
    font-size: ${theme.star.fontSize.xRegular};
    line-height: 1.4286;
    margin: 0;
`);

export const OffersSettingsContentText = withConfig(theme => styled('span', { label: 'OffersSettingsContentText' })`
    font-size: ${theme.star.fontSize.xRegular};
    line-height: 1.4286;
`);
